import Immutable from 'immutable';

// constants
import { PAYMENT_API_RESPONSE_SEND } from '../constants/premiumSubscriptionTypes';

// lib
import httpReducer from '../lib/httpReducer';

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case PAYMENT_API_RESPONSE_SEND:     return httpReducer(state, action);
    default:                            return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/premiumSubscription.js